import { Fragment } from "react/jsx-runtime";

import { useCompany } from "#modules/company/view/useCompany";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";
import { formatPrice, formatTimeString } from "shared";

export const ConceptionCost = ({
  designOfficeHourlyRate,
  designOfficeTime,
}: {
  designOfficeHourlyRate: number | null | undefined;
  designOfficeTime: number | null | undefined;
}) => {
  const { company } = useCompany();

  const timeDisplayFormat = company?.companySettings.timeDisplayFormat;

  return (
    <Fragment>
      <Flex justify={"space-between"}>
        <Text>Taux horaire</Text>
        <Text>{formatPrice(designOfficeHourlyRate, "€/h")}</Text>
      </Flex>

      <Flex justify={"space-between"}>
        <Text>Temps de conception</Text>
        <Text>{formatTimeString(designOfficeTime, timeDisplayFormat)}</Text>
      </Flex>
    </Fragment>
  );
};
